export enum OrderStatusColorEnum {
    BLUE = 'blue',
    ORANGE = 'orange',
    BLACK = 'black',
    GREEN = 'green',
    RED = 'red',
    YELLOW = 'yellow',
}
